import React from "react";
import Heading from "../Heading";
// import Button from "../WinpeButton"
import "./styles.css";
import { Parallax } from "react-parallax";
import EventComponent from "../EventComponent";
import Link from "gatsby-link";
import "animate.css/animate.min.css";
import ScrollAnimation from "react-animate-on-scroll";
const image1 = "https://winpeforum.com/assets/elements/HeroImg.jpg";

let programs = [
  {
    title: "Winpe Collegium",
    desc:
      "Quarterly meetings with partner firms to discuss all matters diversity, exchange knowledge & experiences, identify challenges to attaining gender balance and brainstorm on solutions to address the same. The Collegium identifies action items for each year, along with corresponding annual KPIs, ranging from building diversity in hiring to pay parity and measurement and reporting of diversity. Winpe builds and provides resources needed to support action identified by the Collegium and tracks progress for the collective as well as individual firms.",
    plink: "/maidenCollegium/",
  },
  {
    title: "Winpe Sheshines",
    desc:
      "Evening mixers for women in PEVC and entrepreneurship across Mumbai, Bangalore and Delhi NCR with panel discussions, round tables and close networking.",
    plink: "/SheShines/",
  },
  
  {
    title: "Winpe ProClub",
    desc:
      "Mentorship has been acknowledged as one of the most powerful tools driving professional success. In the case of women, mentorship can be a key success factor as women deal with workplaces largely dominated by men. Winpe's ProClub Mentorship Program connects high performing women with industry leaders for 1:1 mentoring over a period of 12 months. Winpe believes that this initiative will create a deep pipeline of female leaders, facilitating a much-required gender balance in leadership positions and shaping the future course of the industry. Visit the ProClub website for details.",
    plink: "https://proclub.winpeforum.com/home/",
  },
  
  
 
];

let programs1 = [
   
  {
    title: "Winpe Ignite",
    desc:
      "Winpe Ignite aims to nurture young female talent for the industry through quarterly events that include career bootcamps, AMA with industry leaders, dissemination of job opportunities, conversations with senior women, networking events and direct-at-campus engagements.",
    plink: "",
  },
  {
    title: "Winpe WLSA",
    desc:
      "An industry conference providing industry insights and connects to women investors and entrepreneurs. Followed by the Winpe Awards recognizing firms and individuals for their action on gender diversity.",
    plink: "https://winpeleadershipsummit.winpeforum.com/home/",
  },
  
 
];

export default class index extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      activeItem: null,
      isShow: false,
    };
    this.collegiumsText = [
      {
        id: 1,
        title:
          "Winpe partners will step up efforts for diversity in hiring by pushing for a diverse talent pipeline and incorporating a blind screening process (including redacted CVs removing names and other indications of gender, case studies). The diversity targets for inward talent pipeline will be set on a confidential basis to maintain merit and credibility in hiring.",
      },
      {
        id: 2,
        title:
          "Winpe and its partners will support mid career women professionals from the industry through a structured mentorship program to be run by Winpe.",
      },
      {
        id: 3,
        title:
          "Winpe partners will introduce a conversation on diversity within their firms and portfolio companies, enhancing awareness and sensitization within the ecosystem.",
      },
      {
        id: 4,
        title:
          "Winpe partners will seek for their portfolio companies to measure appropriate diversity metrics and report annually.",
      },
      {
        id: 5,
        title:
          "Winpe partners will ask for commitment and measurement on Equal Pay at KMP level in portfolio companies.",
      },
      {
        id: 6,
        title:
          "Winpe partners will support outreach at campuses that are hiring grounds for the industry to champion awareness among female candidates.",
      },
    ];
  }
  toggleEvent = (item) => {
    console.log("activeItem", item);
    window.scrollTo(0, this.refs.test.offsetTop);
    this.setState({
      activeItem: item,
    });
  };
  render() {
    const insideStyles = {
      background: "white",
      padding: 20,
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%,-50%)",
    };
    const { activeItem } = this.state;
    return (
      <div ref="test" className="section__content">
        <div className="key__initiative__wrapper">
          <Parallax bgImage={image1} strength={500}>
            <div style={{ height: "100%" }}>
              {activeItem != null ? (
                <EventComponent
                  activeItem={activeItem}
                  toggleEvent={this.toggleEvent}
                />
              ) : (
                <div className="key__initiative__content">
                  <div className="low__heading"></div>
                  <div className="">
                    <Heading title="Initiatives" />
                  </div>
                  {/* <div className="sub__text__muted">
										Taking the next steps with WINPE
									</div> */}
                  <div className="sub__body__text" style={{textAlign:"center"}}>
                  Winpe has programs in multiple formats for engaging with different constituents of the investing industry including both firms and women.
                  </div>
                  {/*
									<div className="key__initiative__steps">
										{programs.map((item, i) => {
											return <div key={i} className="box__column">
												<div className="box__heading">
													{item.title}
													<div className="bottom__strip" />
												</div>
												<div className="box__desc">
													{item.desc}
												</div>
												<div className="box__btn">
													<Button onClick={() => this.toggleEvent(item)} title={item.subText} />
												</div>
											</div>
										})}
									</div> */}
                  <div className="key__initiative__steps_new">
                    <ScrollAnimation
                      delay={0}
                      duration={3}
                      animateIn="zoomIn"
                      offset={300}
                    >
                      <div className="row">
                        {programs.map((item, i) => {
                          return (
                            <div className="col-md-4 col-sm-6 col-lg-4" key={i}>
                              <a href={item.plink} target="_blank">
                                <div className="box__column_new">
                                  <div className="box__heading">
                                    {item.title}
                                    <div className="bottom__strip" />
                                  </div>
                                  <div className="box__desc">{item.desc}</div>
                                </div>
                              </a>
                            </div>
                          );
                        })}
                      </div> <div className="row"> <div className="col-md-2   col-lg-2"  >
                             
                                
                               
                            </div>
                        {programs1.map((item, i) => {
                          return (
                            <div className="col-md-4 col-sm-6 col-lg-4" key={i}>
                              <a href={item.plink} target="_blank">
                                <div className="box__column_new">
                                  <div className="box__heading">
                                    {item.title}
                                    <div className="bottom__strip" />
                                  </div>
                                  <div className="box__desc">{item.desc}</div>
                                </div>
                              </a>
                            </div>
                          );
                        })}
                      </div>
                    </ScrollAnimation>
                  </div>
                  <div className="event_btn">
                    <div className="events">
                      <div className="event_text">
                        <Link to="/events/"> View Upcoming Events</Link>
                      </div>
                    </div>
                  </div>
                  {/*
										<div className="collegiums_section">
										<div className="collegiums_text_section">
											<div className="collegiums_btn">
											MAIDEN COLLEGIUM OUTCOMES
												<div className="collegiums_text">
													<ol>
														{this.collegiumsText.map((item, i) => {
															return (
																<li key={i}>
																	<div className="">{item.title}</div>
																</li>
															)
														})}
													</ol>
												</div>
											</div>
										</div>
									</div>

									*/}
                </div>
              )}
            </div>
          </Parallax>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/KeyInitiatives/index.js